import { render, staticRenderFns } from "./FoodDistributionLogs.vue?vue&type=template&id=1551e19c&"
import script from "./FoodDistributionLogs.vue?vue&type=script&lang=js&"
export * from "./FoodDistributionLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports